import RatingCommunication from '~/pages/communication/rating/libs/components/RatingCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const RatingCommunicationPage = (props: TPageProps) => (
  <RatingCommunication {...props} />
)

export default RatingCommunicationPage
